<style scoped>
.full-height-width-card {
  min-height: 100vh;
  width: 100vw;
}
.card_shadow {
  background: white 0% 0% no-repeat padding-box;
  box-shadow: 8px 8px 23px #b9b9b9, -8px -8px 23px #ffffff !important;
}
.title {
  font: normal normal normal 24px/36px Roboto;
}
.filled_noline >>> .v-input__slot::before {
  border-style: none !important;
}
.under-line {
  text-decoration: underline;
}
</style>

<template>
  <v-card
    color="transparent"
    flat
    class="full-height-width-card align-center justify-center"
  >
    <v-row justify="center" v-show="step === 'form'">
      <v-col cols="10">
        <v-card class="ma-10 card_shadow align-center justify-center">
          <v-form ref="form" lazy-validation>
            <v-container class="pa-13">
              <v-row justify="center">
                <p class="title">{{ $t('common.langxConsole') }}</p>
              </v-row>
              <v-row justify="center" class="mt-0">
                <p class="title">
                  {{ $t('signUp.registerNewAdminUserRequest') }}
                </p>
              </v-row>
              <v-row justify="center" class="mt-5">
                <v-col cols="10">
                  <v-text-field
                    v-model="candidate.customerCode"
                    :label="$t('common.customerCode')"
                    persistent-placeholder
                    outlined
                    required
                    :rules="[rules.required, rules.onlyAlphaNumericHyphen]"
                    @input="checkValidity"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-n7">
                <v-col cols="10">
                  <v-text-field
                    v-model="candidate.email"
                    :label="$t('common.email')"
                    persistent-placeholder
                    outlined
                    required
                    :rules="[rules.required, rules.emailRules]"
                    :error-messages="emailErrorMessages"
                    @input="checkValidity"
                  ></v-text-field>
                </v-col>
              </v-row>
              <input-new-pass
                :isSignUp="true"
                @setPassword="setPassword"
                @validatePassword="setPasswordValidity"
              />
              <v-row justify="center" class="mt-n7">
                <v-col cols="10">
                  <p
                    class="text-center"
                    v-html="$t('securitySettings.passwordCriteriaDescription')"
                  ></p>
                </v-col>
              </v-row>
              <v-row justify="center" class="mb-10">
                <v-btn
                  :disabled="isButtonDisabled"
                  color="#1b2643"
                  class="white--text"
                  @click="step = 'confirm'"
                >
                  {{ $t('common.register') }}
                </v-btn>
              </v-row>
              <v-row justify="center" class="mt-n7">
                <v-btn
                  text
                  color="blue"
                  class="mt-4 under-line"
                  @click="goToSignIn"
                >
                  {{ $t('signUp.signInHereButton') }}
                </v-btn>
              </v-row>
              <v-snackbar v-model="snackbar">
                {{ snackBarMessage }}
                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="pink"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                  >
                    Close
                  </v-btn>
                </template>
              </v-snackbar>
            </v-container>
          </v-form>
        </v-card>
        <div class="d-flex justify-center">
          <language-switching color="black" />
        </div>
      </v-col>
    </v-row>

    <v-row justify="center" v-show="step === 'confirm'">
      <v-col cols="10">
        <v-card class="ma-10 card_shadow align-center justify-center">
          <v-form ref="form" lazy-validation>
            <v-container class="pa-13">
              <v-row justify="center">
                <p class="title">{{ $t('common.langxConsole') }}</p>
              </v-row>
              <v-row justify="center" class="mt-0">
                <p class="title">{{ $t('signUp.registerWithThisContent') }}</p>
              </v-row>
              <v-row justify="center" class="mt-7">
                <v-col cols="10">
                  <v-text-field
                    v-model="candidate.customerCode"
                    :label="$t('common.customerCode')"
                    readonly
                    persistent-placeholder
                    required
                    class="filled_noline"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10">
                  <v-text-field
                    v-model="candidate.email"
                    :label="$t('common.email')"
                    readonly
                    persistent-placeholder
                    required
                    class="filled_noline"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10">
                  <v-text-field
                    :append-icon="showPassword3 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword3 ? 'text' : 'password'"
                    @click:append="showPassword3 = !showPassword3"
                    v-model="password"
                    :label="$t('common.password')"
                    readonly
                    persistent-placeholder
                    required
                    class="filled_noline"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-5 mb-2">
                <v-btn
                  text
                  color="blue"
                  class="mr-4 under-line"
                  @click="step = 'form'"
                >
                  {{ $t('common.back') }}
                </v-btn>
                <v-btn
                  color="#1b2643"
                  class="white--text"
                  :disabled="isLoading"
                  :loading="isLoading"
                  @click="signUp"
                >
                  {{ $t('common.register') }}
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
        <div class="d-flex justify-center">
          <language-switching color="black" />
        </div>
      </v-col>
    </v-row>

    <v-row justify="center" v-show="step === 'success'">
      <v-col cols="10">
        <v-card class="ma-10 card_shadow align-center justify-center">
          <v-form ref="form" lazy-validation>
            <v-container class="pa-13">
              <v-row justify="center" class="py-8">
                <h2>{{ $t('signUp.registrationThankYouMessage') }}</h2>
                <!-- {{ uid }} -->
              </v-row>
              <v-row justify="center" class="mt-7">
                <p>
                  {{ $t('signUp.confirmationEmailSentMessage') }}
                </p>
              </v-row>
              <v-row justify="center" class="mt-n7">
                <v-btn
                  text
                  color="blue"
                  class="mt-10 under-line"
                  @click="goToSignIn"
                >
                  {{ $t('signUp.moveToSignInScreen') }}
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
        <div class="d-flex justify-center">
          <language-switching color="black" />
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut,
} from "firebase/auth";
import { candidateService } from "@/api/candidateService";
import LanguageSwitching from "@/components/Common/LanguageSwitchingComponent.vue";
import InputNewPass from "@/components/Dashboard/PageViewItems/InputNewPasswordField.vue";
import { auth } from "@/plugins/firebase";

export default defineComponent({
  name: "SignUpView",
  components: {
    InputNewPass,
    LanguageSwitching,
  },
  data() {
    return {
      candidateRef: null,
      candidate: {
        customerCode: "",
        customerName: "",
        email: "",
        password: "",
        isAccepted: false,
      },
      snackbar: false,
      snackBarMessage: "データベース接続エラー",

      step: "form", // 'form' | 'confirm' | 'success'

      password: "",

      showPassword3: false,
      customerName: "",
      customerId: "",
      uid: "",
      isPasswordValid: true,
      isEmailValid: false,
      isCustomerCodeValid: false,
      signUpError: null as string | null,
      isLoading: false,
    };
  },

  created() {
    // サインイン画面を開くと強制サインアウトおよびストレージのリセット
    signOut(auth).then(() => {
      this.$store.commit("reset", this.$store.state);
    });
  },

  methods: {
    async signUp() {
      // Prevent multiple clicks
      if (this.isLoading) return;
      this.isLoading = true;

      // Auth認証及びエラーハンドリング
      try {
        this.$store.commit("setIsCreatingUser", true);
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          this.candidate.email,
          this.password,
        );
        const user = userCredential.user;

        // Use user info for next steps
        this.uid = user.uid;
        this.$store.commit("setEmail", user.email);

        const createdCandidate = await candidateService.create({
          customerCode: this.candidate.customerCode,
          email: this.candidate.email,
          isAccepted: this.candidate.isAccepted,
          uid: this.uid,
        });

        if (!createdCandidate) {
          await signOut(auth);
          this.snackbar = true;
          this.step = "form"; // Show registration form again
          this.$store.commit("setIsCreatingUser", false);
          this.isLoading = false;
          return;
        }
        const url = `${window.location.origin}/verified`;
        sendEmailVerification(user, { url });
        await signOut(auth);
        this.$store.commit("setIsCreatingUser", false);
        this.isLoading = false;
        // Only after all steps succeed, show the thank you/success screen
        this.step = "success";
      } catch (error) {
        if (error && typeof error === "object" && "code" in error) {
          this.signUpError = (error as { code: string }).code;
        }
        console.log(error);
        this.$store.commit("setIsCreatingUser", false);
        this.isLoading = false;
        if (this.signUpError) {
          this.step = "form"; // Show registration form again
        }
      }
    },
    goToSignIn() {
      this.$router.push({ name: "Sign In" });
    },
    // コンポーネントからの値の受け取り
    setPassword(pass: string) {
      this.password = pass;
    },
    setPasswordValidity(isPasswordValid: boolean) {
      this.isPasswordValid = isPasswordValid;
    },
    /**
     * inputイベントが発生時にエラーフラグを初期化して、isCustomerCodeValid、isEmailValidのチェックを行う。
     */
    checkValidity() {
      this.signUpError = "";
      this.isCustomerCodeValid =
        this.rules.onlyAlphaNumericHyphen(this.candidate.customerCode) !== true;
      this.isEmailValid = this.rules.emailRules(this.candidate.email) !== true;
    },
  },
  computed: {
    isButtonDisabled() {
      return !(
        !this.isPasswordValid &&
        !this.isCustomerCodeValid &&
        !this.isEmailValid
      );
    },
    rules() {
      return {
        required: (v: string) => !!v || this.$t("signUp.required"),
        emailRules: (v: string) => {
          const hasEmailFormat = /.+@.+\..+/.test(v);
          return hasEmailFormat || this.$t("signUp.invalidEmailFormat");
        },
        onlyAlphaNumericHyphen: (v: string) => {
          const isOnlyAlphaNumericHyphen = /^[a-zA-Z0-9-]+$/.test(v);
          return (
            isOnlyAlphaNumericHyphen || this.$t("signUp.alphaNumericHyphenOnly")
          );
        },
      };
    },
    emailErrorMessages() {
      if (this.signUpError === "auth/email-already-in-use") {
        return this.$t("signUp.emailAlreadyUsed");
      }
      if (this.signUpError === "auth/invalid-email") {
        return this.$t("signUp.invalidEmailFormat");
      }
      return "";
    },
  },
});
</script>
